import { useEffect, useState } from 'react';

import { useGetStaffsQuery } from '../../../services/staff';
import { useGetStudentsQuery } from '../../../services/students';
import { ProfileIcon } from '../../../services/users/types';
import { UserType } from '../../../types/common';
import { joinNames } from '../../common/formatText';

export type User = {
  id: string,
  name: string,
  firstName: string;
  lastName: string;
  profileIcon: ProfileIcon;
  phoneNumber: string;
  type: UserType
};

const useUsersQuery = ({ search, excludeDisabled } : {
  search?: string,
  excludeDisabled?: boolean,
}, queryOpts?: any) => {
  const {
    data: students,
    isLoading: isStudentsLoading,
    isFetching: isStudentsFetching,
  } = useGetStudentsQuery({
    excludeDisabled,
    search,
  }, queryOpts);
  const {
    data: staff,
    isLoading: isStaffLoading,
    isFetching: isStaffFetching,
  } = useGetStaffsQuery({
    excludeDisabled,
    search,
  }, queryOpts);

  const [users, setUsers] = useState<User[] | undefined>();

  useEffect(() => {
    if (students && staff) {
      const mappedUsers = [...students.data.map((user) => ({
        id: user.id,
        name: joinNames([user.firstName, user.lastName]),
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phoneNumber: user.phoneNumber,
        profileIcon: user.profileIcon,
        type: UserType.Student,
        disabled: user.disabled,
      })), ...staff.data.map((user) => ({
        id: user.id,
        name: joinNames([user.firstName, user.lastName]),
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phoneNumber: user.phoneNumber,
        profileIcon: user.profileIcon,
        type: UserType.Staff,
        disabled: user.disabled,
      }))];
      setUsers(mappedUsers);
    }
  }, [students, staff]);

  return {
    data: users,
    isLoading: isStudentsLoading || isStaffLoading,
    isFetching: isStudentsFetching || isStaffFetching,
  };
};

export default useUsersQuery;
